// Textos de la supervisión (Fase 9). Los usan la vista simple y el Estudio.
import { fmtTime } from '../chat/format';

export const phoneOf = (sid) => (sid ? sid.split('_').slice(1).join('_') : '');

// Estado de una integración: siempre ícono + texto, nunca solo color
export const INTEGRATION_STATUS = {
  up:             { icon: '●', label: 'Conectada',      color: '#22c55e' },
  down:           { icon: '●', label: 'Caída',          color: '#ef4444' },
  not_configured: { icon: '○', label: 'Sin configurar', color: '#64748b' },
  unknown:        { icon: '○', label: 'Revisando…',     color: '#64748b' },
};

export const PRESENCE = {
  online:  { icon: '🟢', label: 'Disponible' },
  paused:  { icon: '⏸', label: 'En pausa' },
  offline: { icon: '⚪', label: 'Desconectado' },
};

// Hoja de sesión
export const SESSION_STATE = {
  queued:         { icon: '⏳', label: 'En cola' },
  attending:      { icon: '💬', label: 'En atención' },
  waiting_client: { icon: '⌛', label: 'Esperando cliente' },
  closed:         { icon: '✔', label: 'Cerrado hoy' },
};

const SEVERITY_ICON = { info: 'ℹ️', warning: '⚠️', error: '⛔' };

/**
 * Texto de un evento de portal_events para las alertas y el historial.
 * @param {object} e       evento
 * @param {(id: string) => string} agentName  nombre visible de un agente de IA
 */
export function describeEvent(e, agentName = (id) => id) {
  const p = e.payload || {};
  const phone = phoneOf(e.session_id);
  switch (e.type) {
    case 'ai_agent.error':
      return `${agentName(e.actor_id)}: error${p.error ? ` (${p.error})` : ''}${p.workflow ? ` en ${p.workflow}` : ''}`;
    case 'ai_agent.policy_rejected':
      return `${agentName(e.actor_id)}: respuesta rechazada por la política${p.reason ? ` (${p.reason})` : ''}`;
    case 'ai_agent.turn_finished':
      return `${agentName(e.actor_id)} respondió${p.intent ? ` (${p.intent})` : ''}`;
    case 'integration.down':
      return `${p.name || e.actor_id} caída${p.error ? `: ${p.error}` : ''}`;
    case 'integration.recovered':
      return `${p.name || e.actor_id} recuperada`;
    case 'integration.zoho_owner_failed':
      return `No se pudo cambiar el responsable en Zoho (${phone})`;
    case 'conversation.waiting_long':
      return `${phone} lleva más de ${p.minutes} min en cola`;
    case 'conversation.window_expiring':
      return `${phone}: la ventana de 24 h vence a las ${fmtTime(p.expires_at)}`;
    case 'message.send_failed':
      return `Envío fallido a ${phone}${p.error ? `: ${p.error}` : ''}`;
    case 'message.store_failed':
      return `Mensaje a ${phone} enviado pero no guardado en el historial`;
    case 'template.status_changed':
      return `Plantilla ${p.name}: ${p.status}${p.reason ? ` (${p.reason})` : ''}`;
    case 'sara.replied_while_assigned':
      return `SARA respondió en ${phone} con el caso asignado${p.paused_again === false ? ' (no se pudo pausar de nuevo)' : ': se pausó de nuevo'}`;
    case 'template.header_image_set':
      return `Imagen cargada en la plantilla ${p.name}`;
    case 'template.header_image_removed':
      return `Imagen quitada de la plantilla ${p.name || ''}`.trim();
    case 'conversation.escalated':
      return `Caso escalado: ${phone}`;
    case 'conversation.closed':
      return `Caso cerrado: ${phone}`;
    default:
      return `${e.type}${phone ? ` · ${phone}` : ''}`;
  }
}

export const severityIcon = (sev) => SEVERITY_ICON[sev] || SEVERITY_ICON.info;

// Intenciones de SARA → qué está haciendo el agente (texto corto)
const INTENT_TEXT = {
  program_information: 'informando programas',
  prices: 'cotizando',
  schedule_visit: 'agendando visita',
  update_data: 'actualizando datos',
  talk_to_human: 'pasando a un asesor',
  greeting: 'saludando',
};
export const intentText = (intent) => (intent ? INTENT_TEXT[intent] || intent.replace(/_/g, ' ') : 'atendiendo');

// Estado de la conversación en la que trabajó un agente de IA
export const CONV_STATUS = {
  bot: 'sigue con la IA',
  queued: 'en cola para un asesor',
  assigned: 'con un asesor',
  closed: 'cerrada',
};
